/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1200px){.office-name[_ngcontent-%COMP%]{color:#007dc3}.navigation[_ngcontent-%COMP%]{width:204px}app-profile-header[_ngcontent-%COMP%]     app-circle-initials .initials{color:#004e9b;height:100px;width:100px;font-size:4rem}.block-break[_ngcontent-%COMP%]{border-color:#c4c6c8}}@media (min-width:900px){app-profile-header[_ngcontent-%COMP%]     app-circle-initials .initials{height:200px;width:200px;font-size:6rem}.primary-info.wrapper[_ngcontent-%COMP%]{padding-bottom:40px}}"];
export { styles as styles };
